import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Instagram } from "lucide-react";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_design-fasaad/artifacts/1dnozd6v_FaSaaD%20MiMAR%20white%20copy%20l.png";
const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_design-fasaad/artifacts/3rubfvbq_FaSaaD%20MiMAR%20Black%20copy%20l.png";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const links = [
    { path: "/", label: "Work" },
    { path: "/about", label: "Studio" },
    { path: "/contact", label: "Contact" },
  ];

  // Determine if we're on a dark hero page
  const isDarkHero = location.pathname === "/" || location.pathname === "/about";
  const showWhiteLogo = isDarkHero && !scrolled && !mobileOpen;

  return (
    <>
      <nav data-testid="main-navigation" className={`nav-wrapper ${scrolled ? "scrolled" : ""}`}>
        <div className="w-full pl-3 pr-16 lg:pl-3 lg:pr-40">
          <div className="flex items-center justify-between h-24 lg:h-36">
            <Link to="/" data-testid="logo-link" className="relative z-[301]">
              <img 
                src={mobileOpen ? LOGO_WHITE : (showWhiteLogo ? LOGO_WHITE : LOGO_BLACK)}
                alt="FaSaad Mimar"
                className="h-24 lg:h-36 w-auto transition-opacity duration-300"
              />
            </Link>

            <div className="hidden lg:flex items-center gap-16">
              {links.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                  className={`nav-link ${location.pathname === link.path ? "active" : ""}`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://www.instagram.com/fasaadmimar/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-link"
                className="nav-link"
              >
                <Instagram size={16} />
              </a>
            </div>

            <button
              data-testid="mobile-menu-toggle"
              className={`hamburger lg:hidden ${mobileOpen ? "active" : ""}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>

      <div data-testid="mobile-menu" className={`mobile-overlay ${mobileOpen ? "open" : ""}`}>
        {links.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
            className="mobile-link"
          >
            {link.label}
          </Link>
        ))}
        <a
          href="https://www.instagram.com/fasaadmimar/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 text-[#F5F5F3]"
        >
          <Instagram size={24} />
        </a>
      </div>
    </>
  );
};
